import axios from '../axios';

const getPolicy = () => axios.get("api/settings/policy");

export default getPolicy;
